import { useMemo } from "react";
import { useApi, apiResolver } from "@/api/useApi";
import { TenantStatusData } from "./TenantStatus.model";
import { useQuery } from "react-query";

export function useTenantStatusApi(tenantId: string) {
  const { api } = useApi();

  return useMemo(
    () => ({
      getTenantStatus: async () => apiResolver<TenantStatusData>(api.get(`/gateway/tenant/${tenantId}/status`)),
    }),
    [api, tenantId]
  );
}

export function useGetTenantStatus(tenantId: string, enabled: boolean = true) {
  const { getTenantStatus } = useTenantStatusApi(tenantId);

  return useQuery({
    queryKey: `tenant-status`,
    queryFn: () => getTenantStatus(),
    enabled: enabled && !!tenantId,
  });
}
